import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aboutpage-about',
  templateUrl: './aboutpage-about.component.html',
  styleUrls: ['./aboutpage-about.component.scss']
})
export class AboutpageAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
